// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"89a61b54","144":"90d1080e","152":"5b8da920","171":"2c61c977","453":"5af67ccb","466":"5354622e","504":"171649fc","507":"8d5b2b9b","521":"18d70de4","599":"b0d1c3a4","743":"56055aa6","749":"6d1ef052","780":"d1fe076a","938":"b7ef6257","968":"0bf90641"}[chunkId] + ".chunk.js";
};